import React from 'react';
import { X } from 'lucide-react';
import { formatWorkflowDate } from '../../utils/workflowInsightsApi';

const WorkflowPathInfoCard = ({ executionPathView, onExit }) => {
  if (!executionPathView) return null;

  const contactName = executionPathView.contact_name
    || executionPathView.contact_details
    || 'Unknown contact';

  return (
    <div
      className="pointer-events-auto absolute left-4 top-4 z-30 max-w-sm rounded-xl border border-slate-200 bg-white p-4 shadow-lg"
      data-testid="workflow-path-info-card"
    >
      <div className="mb-3 flex items-start justify-between gap-3">
        <div>
          <p className="text-xs font-medium uppercase tracking-wide text-slate-500">Contact</p>
          <p className="text-sm font-semibold text-slate-900">{contactName}</p>
        </div>
        {onExit && (
          <button
            type="button"
            onClick={onExit}
            className="rounded-md p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-600"
            aria-label="Close path view"
            data-testid="workflow-path-info-close"
          >
            <X size={16} />
          </button>
        )}
      </div>
      <dl className="space-y-2 text-xs text-slate-600">
        {executionPathView.contact_id && (
          <div>
            <dt className="text-slate-500">Contact ID</dt>
            <dd className="font-mono text-[11px] text-slate-700">{executionPathView.contact_id}</dd>
          </div>
        )}
        {executionPathView.execution_id && (
          <div>
            <dt className="text-slate-500">Execution ID</dt>
            <dd className="font-mono text-[11px] text-slate-700 break-all">{executionPathView.execution_id}</dd>
          </div>
        )}
        {executionPathView.enrollment_date && (
          <div>
            <dt className="text-slate-500">Enrollment date</dt>
            <dd>{formatWorkflowDate(executionPathView.enrollment_date)}</dd>
          </div>
        )}
        {executionPathView.workflow_version != null && (
          <div>
            <dt className="text-slate-500">Workflow version</dt>
            <dd>{executionPathView.workflow_version}</dd>
          </div>
        )}
      </dl>
      <p className="mt-3 text-xs text-slate-500">
        Workflow is not editable in execution path view. Stats are only available for the last 30 days.
      </p>
      {onExit && (
        <button
          type="button"
          onClick={onExit}
          className="mt-3 text-sm font-medium text-sky-600 hover:text-sky-700"
          data-testid="workflow-path-exit"
        >
          Exit path view
        </button>
      )}
    </div>
  );
};

export default WorkflowPathInfoCard;
